import ItemStars from '@/reviewer/components/items/ItemStars.vue';
import ItemTextArea from '@/reviewer/components/items/ItemTextArea.vue';
import ItemRadioButtons from '@/reviewer/components/items/ItemRadioButtons.vue';
import ItemDropdown from '@/reviewer/components/items/ItemDropdown.vue';
import ItemSlider from '@/reviewer/components/items/ItemSlider.vue';
import ItemCheckboxes from '@/reviewer/components/items/ItemCheckboxes.vue';
import ItemNoField from '@/reviewer/components/items/ItemNoField.vue';
import ItemMedia from '@/reviewer/components/items/ItemMedia.vue';
import ItemTextInput from '@/reviewer/components/items/ItemTextInput.vue';


// eslint-disable-next-line import/prefer-default-export
export const ITEM_COMPONENTS = {
  stars: ItemStars,
  text: ItemTextArea,
  radio_buttons: ItemRadioButtons,
  dropdown: ItemDropdown,
  slider: ItemSlider,
  check_boxes: ItemCheckboxes,
  no_field: ItemNoField,
  media: ItemMedia,
  input: ItemTextInput,
};
